import { createAction } from '@reduxjs/toolkit';
import { Post } from '../../../../../../../common/entities/entities.types';
import constants from '../post-filter.constants';

export const setPostfilter = (searchFilterName: string) => createAction<Post[]>(`${searchFilterName}_${constants.SET_POST_FILTER}`);
export const applyPostfilter = (searchFilterName: string) => createAction<Post[]>(`${searchFilterName}_${constants.APPLY_POST_FILTER}`);
export const setPostSelectModalVisible = (searchFilterName: string) => createAction<boolean>(`${searchFilterName}_${constants.SET_POST_MODAL_VISIBILITY}`);
export const setIsPostFetching = (searchFilterName: string) => createAction<boolean>(`${searchFilterName}_${constants.SET_IS_POST_FECTHING}`);
